import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import { usePromiseTracker } from 'react-promise-tracker';

const LoadingSpinner = () => {
  const { promiseInProgress } = usePromiseTracker();
  if (promiseInProgress) {
    return (
      <Dimmer inverted page active>
        <Loader inverted size="large" inline="centered">
          Loading
        </Loader>
      </Dimmer>
    );
  }

  return <div />;
};

export default LoadingSpinner;
